import React, { PureComponent } from "react";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import isEqual from "lodash/isEqual";
import { withTranslation } from "react-i18next";
import withStyles from "@mui/styles/withStyles";
import { Typography, Button, Box } from "@mui/material";
import Table from "../../components/Table/Table";
import { DropdownSelectFilled } from "../../components/DropdownSelect";
import ScoreCell from "../../components/ScoreCell";
import * as userActions from "../../redux/actions/userActions";
import {
  fetchReportData,
  updateFilterValue
} from "../../redux/actions/transcriptReportActions";
import { transcriptReportFilterCriteria } from "../../constants";

const columns = [
  {
    title: "Course Title",
    field: "courseTitle",
    cellStyle: {
      minWidth: 200
    }
  },
  {
    title: "Date Completed",
    field: "completedAt",
    options: {
      sorting: true
    },
    type: "date",
    cellStyle: {
      width: 170
    }
  },
  {
    title: "score",
    field: "postScore",
    cellStyle: {
      width: 170
    },
    render: rowData => (
      <ScoreCell
        scoreInfo={rowData.scoreInfo}
        isSelfAssigned={rowData.isSelfAssigned}
        passingScore={rowData.passingScore}
        courseType={rowData.courseType}
        passedCompletionDate={rowData.passedCompletionDate}
      />
    )
  }
];
const styles = theme => ({
  root: {
    marginTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    display: "flex",
    flexDirection: "column"
  },
  filterBtn: {
    margin: theme.spacing(1, 0, 1, 0)
  }
});

// const emailCertificateUrl = `${visionURL}/certificates/email`;
// const emailReportUrl = `${visionURL}/reports/8838/run_report`;
// const printCertificateUrl = `${visionURL}/certificates/print`;
// const printReportUrl = `${visionURL}/reports/8838/run_report`;

class TranscriptReport extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tableFilter: transcriptReportFilterCriteria[0].label
    };
    this.tableRef = React.createRef();
  }

  handleApplyFiltersChange = filter => {
    const { tableFilter } = this.state;
    this.props.updateFilterValue(filter.value);
    if (!isEqual(tableFilter, filter)) {
      this.setState(
        {
          tableFilter: filter
        },
        () => this.tableRef.current && this.tableRef.current.onQueryChange()
      );
    }
  };

  handleFetchReportData = queryData => {
    return this.props.fetchReportData(queryData, this.state.tableFilter.value);
  };

  render() {
    const { classes, t } = this.props;
    const dateObj = new Date();
    let locale = this.props.userState.user.settings.preferred_language
      ? this.props.userState.user.settings.preferred_language
      : "en";
    const dateStr = dateObj.toLocaleString(locale, {
      month: "long",
      day: "2-digit",
      year: "numeric"
    });

    return (
      <div className={classes.root}>
        <Box
          mb={4}
          display="flex"
          justifyContent="space-between"
          flexDirection={{ xs: "column-reverse", sm: "row" }}
        >
          <Box
            display="flex"
            justifyContent={{ xs: "space-between", sm: "flex-start" }}
          >
            <Box display="flex" alignItems="center" mr={{ xs: 1, sm: 3 }}>
              <Typography variant="subtitle1" color="textSecondary">
                {t("performance.transcriptReport.filterCriteria")}
              </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              width={{ xs: 140, sm: 274 }}
              mr={{ xs: 1, sm: 3 }}
            >
              <DropdownSelectFilled
                options={transcriptReportFilterCriteria}
                value={this.state.tableFilter}
                backgroundColor={"white"}
                onChange={this.handleApplyFiltersChange}
                disableUnderline
              />
            </Box>
            <Button
              className={classes.filterBtn}
              key="Filter "
              variant="contained"
              color="primary"
            >
              {t("performance.transcriptReport.filter")}
            </Button>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems={{ xs: "center", sm: "flex-end" }}
            mb={{ xs: 3, sm: 0 }}
          >
            <Typography variant="caption" color="textSecondary">
              {t("performance.transcriptReport.reportDate")}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              {dateStr}
            </Typography>
          </Box>
        </Box>
        <Table
          columns={columns}
          data={this.handleFetchReportData}
          filtering={false}
          tableRef={this.tableRef}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userState: state.userState,
  tableFilter: state.transcriptReportState.tableFilter
});

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActions, dispatch),
  fetchReportData: bindActionCreators(fetchReportData, dispatch),
  updateFilterValue: bindActionCreators(updateFilterValue, dispatch)
});

const TranslatedTranscriptReport = withTranslation()(TranscriptReport);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(TranslatedTranscriptReport);
